import { FixedPrice, SaleDurationInTimestamp } from 'rain-sdk';
export const saleStatuses = ["Pending", "Active", "Success", "Fail"];
export function canEndConfig(endTimeStamp, minimumRaise, decimals) {
    const _saleTime_ = new SaleDurationInTimestamp(endTimeStamp);
    _saleTime_.afterMinimumRaise(minimumRaise, decimals);
    return _saleTime_;
}
export function calculatePriceConfig(price, decimals, maxWalletCap) {
    const saleSelector = () => {
        return new FixedPrice(price, decimals);
    };
    const _sale_ = saleSelector();
    _sale_.applyWalletCap(1, { maxWalletCap: maxWalletCap });
    return _sale_;
}
